module.exports = __webpack_public_path__ + "static/media/discount-timer-checked.95f607e4.svg";